export default __webpack_public_path__ + "static/media/lemontbotanique_background_l2.b549de55.jpg";